import ShoppingTrolleyIconPath from "@ingka/ssr-icon/paths/shopping-trolley";

export default ShoppingTrolleyIconPath;
